import Vue from 'vue'
import VueRouter from 'vue-router'
import UtilityService from '../services/utility-service.js';

import Search from '../components/Search.vue'
import SelectArea from '../components/SelectArea.vue'
import Map from '../components/Map.vue'
import GrepFilter from '../components/GrepFilter.vue'
import Detail from '../components/Detail.vue';

import VueGtm from '@gtm-support/vue2-gtm';
import ConfigService from '../services/config-service.js';

Vue.use(VueRouter)

const routes = [
  { 
    path: '*',
    redirect: '/'
  },
  {
    path: '/',
    name: 'Search',
    component: UtilityService.extendComponent('Search', Search, 'slide'),
    meta: {
      gtm: 'トップ'
    },
    children: [
      {
        path: '/area',
        name: 'SelectArea',
        component: UtilityService.extendComponent('SelectArea', SelectArea, 'slide'),
        meta: {
          gtm: 'エリア検索'
        },
      },
      {
        path: '/filter',
        name: 'GrepFilter',
        component: UtilityService.extendComponent('GrepFilter', GrepFilter, 'lift'),
        meta: {
          gtm: '条件検索'
        },
      },
      {
        path: '/map',
        name: 'Map',
        component: UtilityService.extendComponent('Map', Map, 'slide'),
        meta: {
          gtm: '地図'
        },
        children: [
          {
            path: '/detail/:id',
            name: 'Detail',
            props: true,
            component: UtilityService.extendComponent('Detail', Detail, 'slide'),
            meta: {
              gtm: '詳細'
            },
          },
          {
            path: '/filter',
            name: 'GrepInFilter',
            component: UtilityService.extendComponent('GrepFilter', GrepFilter, 'lift'),
            meta: {
              gtm: '地図_条件検索'
            },
          },
          // 現在未使用
          {
            path: '/area',
            name: 'SelectInArea',
            component: UtilityService.extendComponent('SelectArea', SelectArea, 'slide'),
            meta: {
              gtm: '地図_エリア検索'
            },
          }   
        ]
      }
    ],
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  beforeRouteEnter() {
  }
})

Vue.use(VueGtm, {
  id: ConfigService.getGTMId(),
//   queryParams: {
//     gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
//     gtm_preview: 'env-4',
//     gtm_cookies_win: 'x'
//   },
//   defer: false,
//   compatibility: false,
//   nonce: '2726c7f26c',
  enabled: true,
  debug: true,
  // loadScript: true,
  vueRouter: router,
//   // ignoredViews: ['homepage'],
//   trackOnNextTick: false
});

export default router
